<template>
<div class="settings">
    <div class="columns">
        <div class="column is-one-quarter">
            <div class="columns">
                <div class="column is-11">
                    <settings-menu active-item="2fa"></settings-menu>
                </div>
            </div>
        </div>
        <div class="column">
            <div class="settings-container">
                <div class="columns">
                    <div v-if="loading" class="column is-full has-text-centered">
                        <img src="/loader-dark.svg">
                    </div>
                    <div v-if="!loading" class="column is-full">
                        <div class="columns">
                            <div class="column is-3">
                                <div class="columns is-multiline">
                                    <div class="column is-full">
                                        <div class="plan-page-label">Two Factor Authentication</div>
                                        <div class="plan-page-description" style="font-size:13px !important;">
                                            {{ tfaMessage }}
                                        </div>
                                    </div>
                                    <div v-if="base64QrCode && tfaCanBeEnabled" class="column is-10">
                                        <img :src="base64QrCode">
                                    </div>
                                </div>
                            </div>

                            <div class="column is-9" style="padding-left: 60px;">
                                <div v-if="!tfaCanBeEnabled" class="columns">
                                    <div class="column is-full">
                                        <div class="notification is-danger" style="font-size:13px;">
                                            Two Factor Authentication cannot be enabled for accounts connected via Github.
                                        </div>
                                    </div>
                                </div>
                                <div v-if="tfaCanBeEnabled" class="columns is-multiline">
                                    <div class="column is-full">
                                        <input v-model="description" type="text" class="input custom-input-size is-medium" :disabled="tfaEnabled == true || updating" :class="{ 'is-danger': hasError('description') }" placeholder="Device description (e.g. John's smartphone)">
                                        <span v-if="hasError('description')" class="help is-danger">{{ getError('description') }}</span>
                                    </div>
                                    <div class="column is-full">
                                        <input v-model="accountPassword" type="password" class="input custom-input-size is-medium" :disabled="updating" :class="{ 'is-danger': hasError('account_password') }" placeholder="The password of your Weap.io account">
                                        <span v-if="hasError('account_password')" class="help is-danger">{{ getError('account_password') }}</span>
                                    </div>
                                    <div v-if="!tfaEnabled" class="column is-full">
                                        <input v-model="otp" type="text" class="input custom-input-size is-medium" :disabled="updating" :class="{ 'is-danger': hasError('otp') }" placeholder="OTP generated by G. Authenticator after scanning the QR code">
                                        <span v-if="hasError('otp')" class="help is-danger">{{ getError('otp') }}</span>
                                    </div>
                                    <div class="column is-full">
                                        <div v-if="!tfaEnabled" @click="updateTfa" :disabled="updating" :class="{ 'is-loading': updating }" class="button custom-button-size is-fullwidth is-info">Enable 2FA</div>
                                        <div v-if="tfaEnabled" @click="disableTfa" :disabled="updating" :class="{ 'is-loading': updating }" class="button custom-button-size is-fullwidth is-info">Disable 2FA</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style>
.swal-wide {
    width:850px !important;
}
</style>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';
import FormErrorsMixin from '@/mixins/FormErrors';

import SettingsMenu from '@/components/Settings/Menu.vue';

export default {
    components: {
        SettingsMenu,
    },

    mixins: [FormErrorsMixin],

    metaInfo: {
        title: 'Two Factor Authentication - Weap.io',
    },

    data() {
        return {
            qrCodeBase64: null,
            description: null,
            recoverKey: null,
            accountPassword: null,
            tfaEnabled: null,
            tfaCanBeEnabled: true,
            otp: null,
            loading: false,
            updating: false,
            allowedInputs: ['description', 'otp', 'account_password'],
        }
    },

    mounted() {
        this.getTfa();
    },

    methods: {
        getTfa(successCallback) {
            this.loading = true;

            Api().get('/users/current/tfa')
                .then((response) => {
                    this.qrCodeBase64 = response.data.qr_code_base64;
                    this.description = response.data.description;
                    this.recoverKey = response.data.recover_key;
                    this.tfaEnabled = response.data.tfa_enabled;
                    this.tfaCanBeEnabled = response.data.tfa_can_be_enabled;

                    if (typeof successCallback == 'function') {
                        successCallback();
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        updateTfa() {
            if (this.updating) {
                return;
            }

            this.updating = true;
            this.resetErrors();

            var data = {
                description: this.description,
                otp: this.otp,
                account_password: this.accountPassword,
            };

            swal({
                title: 'Recover key: ' + this.recoverKey,
                text: 'This key is used to authenticate you in case you lose access to your 2FA device. Please save it in a safe place. If you lose this key and you don\'t have access to you 2FA device, you will not be able to access your Weap.io account anymore.',
                dangerMode: true,
                buttons: {
                    cancel: 'Cancel',
                    confirm: {
                        text: 'I saved the key, proceed',
                        value: true,
                        closeModal: false,
                    }
                },
                icon: 'warning',
                className: 'swal-wide',
            })
            .then((value) => {
                if (!value) {
                    swal.close();
                    this.updating = false;
                    return;
                }

                Api().put('/users/current/tfa', data)
                .then((response) => {
                    this.getTfa(() => {
                        swal.close();
                        Swal.fire({
                            title: 'Done!',
                            text: '2FA was enabled for your account.',
                            type: 'success',
                        });
                        this.accountPassword = '';
                    });
                })
                .catch((error) => {
                    swal.close();

                    if (!this.storeErrors(error.response.data.errors)) {
                        var message = 'Something wrong happened. Refresh the page and try again.';
                        if (typeof error.response.data.message == 'string') {
                            message = error.response.data.message;
                        }

                        Swal.fire({
                            title: 'Oops',
                            text: message,
                            type: 'error',
                        });
                    }
                })
                .finally(() => {
                    this.updating = false;
                });
            });
        },

        disableTfa() {
            if (this.updating) {
                return;
            }

            this.updating = true;
            this.resetErrors();

            var data = {
                account_password: this.accountPassword,
            };

            Api().delete('/users/current/tfa', {data: data})
                .then((response) => {
                    this.getTfa(() => {
                        Swal.fire({
                            title: 'Done!',
                            text: '2FA was disabled for your account.',
                            type: 'success',
                        });
                    });
                    this.accountPassword = '';
                    this.otp = '';
                })
                .catch((error) => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        var message = 'Something wrong happened. Refresh the page and try again.';
                        if (typeof error.response.data.message == 'string') {
                            message = error.response.data.message;
                        }

                        Swal.fire({
                            title: 'Oops',
                            text: message,
                            type: 'error',
                        });
                    }
                })
                .finally(() => {
                    this.updating = false;
                });
        },

        // resetInputs() {
        //     this.accountPassword = '';
        //     this.description = '';
        //     this.inputs.current_password = '';
        // },
    },

    computed: {
        base64QrCode() {
            if (!this.qrCodeBase64) {
                return null;
            }

            return 'data:image/png;base64,' + this.qrCodeBase64;
        },

        tfaMessage() {
            if (this.tfaEnabled) {
                return '2FA is enabled for your account.'; 
            }

            return 'To enable 2FA, scan the QR code below using Google Authenticator and fill out the details in the form.';
        },
    },
}
</script>
